import React from 'react';
import ReactPlayer from 'react-player';

export default function Video({ theme, video, width, height }) {
	return (
		<div className={`video ${theme}`}>
			<ReactPlayer url={video} width={width} height={height} />
		</div>
	);
}
